var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../../element-factory";
import { SurveyElementBase } from "../../reactquestion_element";
import { SvgIcon } from "../svg-icon/svg-icon";
import { ListItem } from "./list-item";
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeydown = function (event) {
            _this.model.onKeyDown(event);
        };
        _this.handleMouseMove = function (event) {
            _this.model.onMouseMove(event);
        };
        _this.state = {
            filterString: _this.model.filterString || ""
        };
        _this.listContainerRef = React.createRef();
        return _this;
    }
    Object.defineProperty(List.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    List.prototype.getStateElement = function () {
        return this.model;
    };
    List.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (!!this.listContainerRef && !!this.listContainerRef.current) {
            this.model.initListContainerHtmlElement(this.listContainerRef.current);
        }
    };
    List.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a;
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        if (this.model !== prevProps.model) {
            if (this.model && !!((_a = this.listContainerRef) === null || _a === void 0 ? void 0 : _a.current)) {
                this.model.initListContainerHtmlElement(this.listContainerRef.current);
            }
            if (prevProps.model) {
                prevProps.model.initListContainerHtmlElement(undefined);
            }
        }
    };
    List.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (!!this.model) {
            this.model.initListContainerHtmlElement(undefined);
        }
    };
    List.prototype.renderElement = function () {
        return (React.createElement("div", { className: this.model.cssClasses.root, ref: this.listContainerRef },
            this.searchElementContent(),
            this.emptyContent(),
            this.renderList()));
    };
    List.prototype.renderList = function () {
        if (!this.model.renderElements)
            return null;
        var items = this.renderItems();
        var ulStyle = { display: this.model.isEmpty ? "none" : null };
        return (React.createElement("ul", { className: this.model.getListClass(), style: ulStyle, role: this.model.listRole, "aria-label": this.model.a11ya11y_input_ariaLabel, id: this.model.elementId, onMouseDown: function (e) {
                e.preventDefault();
            }, onKeyDown: this.handleKeydown, onMouseMove: this.handleMouseMove }, items));
    };
    List.prototype.renderItems = function () {
        var _this = this;
        if (!this.model) {
            return null;
        }
        var items = this.model.renderedActions;
        if (!items) {
            return null;
        }
        return items.map(function (item, itemIndex) {
            return (React.createElement(ListItem, { model: _this.model, item: item, key: "item" + itemIndex }));
        });
    };
    List.prototype.searchElementContent = function () {
        var _this = this;
        if (!this.model.showFilter)
            return null;
        else {
            var onChange = function (e) {
                var _a;
                var activeElement = (_a = e.target.getRootNode()) === null || _a === void 0 ? void 0 : _a.activeElement;
                if (e.target === activeElement) {
                    _this.model.filterString = e.target.value;
                }
            };
            var onKeyUp = function (e) {
                _this.model.goToItems(e);
            };
            var clearButton = this.model.showSearchClearButton && !!this.model.filterString ?
                React.createElement("button", { className: this.model.cssClasses.searchClearButtonIcon, onClick: function (event) { _this.model.onClickSearchClearButton(event); } },
                    React.createElement(SvgIcon, { iconName: "icon-searchclear", size: "auto" })) : null;
            return (React.createElement("div", { className: this.model.cssClasses.filter },
                React.createElement("div", { className: this.model.cssClasses.filterIcon },
                    React.createElement(SvgIcon, { iconName: "icon-search", size: "auto" })),
                React.createElement("input", { type: "text", className: this.model.cssClasses.filterInput, "aria-label": this.model.filterStringPlaceholder, placeholder: this.model.filterStringPlaceholder, value: this.state.filterString, onKeyUp: onKeyUp, onChange: onChange }),
                clearButton));
        }
    };
    List.prototype.emptyContent = function () {
        var style = { display: this.model.isEmpty ? null : "none" };
        return (React.createElement("div", { className: this.model.cssClasses.emptyContainer, style: style },
            React.createElement("div", { className: this.model.cssClasses.emptyText, "aria-label": this.model.emptyMessage }, this.model.emptyMessage)));
    };
    return List;
}(SurveyElementBase));
export { List };
ReactElementFactory.Instance.registerElement("sv-list", function (props) {
    return React.createElement(List, props);
});
